module.exports = __webpack_public_path__ + "static/newconstructionthumb-dac66fbd19cd0c08351e2749f3e62366.jpg";